export const GROUP_TAB_INDEX = 100
